import { render, staticRenderFns } from "./UserEditSelfForm.vue?vue&type=template&id=208d0262&"
import script from "./UserEditSelfForm.vue?vue&type=script&lang=js&"
export * from "./UserEditSelfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports